import {NavigateToScreenRequest} from '@ui-tool/core';
import {ArticleCategories, ScreenCodes} from '@mobile-data-access-enums';
import {ArticleDetailQueryParams} from '@mobile-data-access-models';

export class ChemotherapyArticleOralMedNavigationRequest extends NavigateToScreenRequest<void> {

    //#region Constructor

    public constructor(source: ScreenCodes, sourceId: string, articleId: string) {
        super(ScreenCodes.DETAILED_ARTICLE, void(0), {
            queryParams: new ArticleDetailQueryParams(source, sourceId, articleId, ArticleCategories.CHEMOTHERAPY_ARTICLE_ORAL_MED)
        });
    }

    //#endregion

}
